(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["es6-menu-aim"] = factory();
	else
		root["es6-menu-aim"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var es6_menu_aim_types_1 = __webpack_require__(1);

var MOUSE_LOCS_TRACKED = 3,
    // number of past mouse locations to track
DELAY = 300; // ms delay when user appears to be entering submenu
// all instances of this class should use the same mouse-move event listener

var _mouseLocs = [],
    // counting instances ... this is used to detect if
// `_mousemoveDocument` should be unregistered
_instanceCounter = 0;
/**
 * Main class of MenuAim
 */

var MenuAim =
/*#__PURE__*/
function () {
  /**
   * Constructor function
   * @param menu root menu HTML element
   * @param opts (optional) config options (see [Options](#options))
   */
  function MenuAim(menu, opts) {
    _classCallCheck(this, MenuAim);
    this.activeRow = null;
    this.lastDelayLoc = null;
    this.timeoutId = null;
    this.exitTimeoutID = null;
    this.options = null;
    this.menu = null;
    /**
     * This method is called initially and each time a menu is re-activated
     */

    this.attach = function (menu) {
      this.menu = menu;

      if (this.options.isRoot) {
        // only the ROOT instance should be registering the `menuExit`
        // event ... all the contained child instances will be hidden by the root instance
        this.menu.addEventListener('mouseleave', this.mouseleaveMenu);
      }
      if (++_instanceCounter === 1) {
        // IF this is the first instance
        // > register the single mouse move event handler - only one is needed
        document.addEventListener('mousemove', _mousemoveDocument);
      }
    };
    /**
     * Dummy function which is used as default value for event listeners
     */


    var noop = function noop() {};

    opts = opts || {}; // setting the default values
    this.options = {
      rowSelector: opts.rowSelector || "> li",
      exitDelay: opts.exitDelay || null,
      submenuSelector: opts.submenuSelector || "*",
      submenuDirection: opts.submenuDirection || es6_menu_aim_types_1.MenuDirection.right,
      tolerance: opts.tolerance || 75,
      isRoot: opts.isRoot || true,
      enter: opts.enter || noop,
      exit: opts.exit || noop,
      activate: opts.activate || noop,
      deactivate: opts.deactivate || noop,
      exitMenu: opts.exitMenu || noop,
      clickRow: opts.clickRow || noop
    }; // binding event handlers

    this.mouseenterRow = this.mouseenterRow.bind(this);
    this.mouseleaveRow = this.mouseleaveRow.bind(this);
    this.clickRow = this.clickRow.bind(this);
    this.mouseleaveMenu = this.mouseleaveMenu.bind(this);
    this.commitExit = this.commitExit.bind(this); // attaching event listeners


    if(menu !== null && menu.querySelector(this.options.rowSelector) !== null){
	    menu.querySelectorAll(this.options.rowSelector).forEach((ele, idx) => {
		    ele.addEventListener('mouseenter', this.mouseenterRow);
		    ele.addEventListener('mouseleave', this.mouseleaveRow);
		    ele.addEventListener('click', this.clickRow);
        })
    }
    this.attach(menu);
  }
  /**
   * Cancel possible row activations when leaving the menu entirely
   * @param ev Mouse Event
   */


  _createClass(MenuAim, [{
    key: "mouseleaveMenu",
    value: function mouseleaveMenu(ev) {
      if (this.timeoutId) {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      if (this.options.exitDelay) {
        if (this.exitTimeoutID) {
          // IF the scheduling timer already exists -> clear it
          window.clearTimeout(this.exitTimeoutID);
          this.exitTimeoutID = null;
        }

        this.exitTimeoutID = window.setTimeout(this.commitExit, this.options.exitDelay);
      } else {
        this.commitExit();
      }
    }
    /**
     * Hides all the sub-menus and the menu. It can be called externally
     */

  }, {
    key: "forceExit",
    value: function forceExit() {
      // clear the exit timeout ... if it's set
      if (this.exitTimeoutID) {
        window.clearTimeout(this.exitTimeoutID);
      }

      this.commitExit();
    }
    /**
     * Closes the menu
     */

  }, {
    key: "commitExit",
    value: function commitExit() {
      this.timeoutId = this.exitTimeoutID = null; // IF exitMenu is supplied and returns true, deactivate the
      // currently active row on menu exit.

      if (this.options.exitMenu(this)) {
        if (this.activeRow) {
          this.options.deactivate(this.activeRow);
        }

        this.activeRow = null;
      }
    }
    /**
     * Trigger a possible row activation whenever entering a new row.
     * @param ev Mouse event
     */

  }, {
    key: "mouseenterRow",
    value: function mouseenterRow(ev) {
      if (this.exitTimeoutID) {
        // console.log('schedule Exit CLEAR');
        clearTimeout(this.exitTimeoutID);
        this.exitTimeoutID = null;
      }

      if (this.timeoutId) {
        // Cancel any previous activation delays
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      this.options.enter(ev.currentTarget);
      this.possiblyActivate(ev.currentTarget);
    }
  }, {
    key: "mouseleaveRow",
    value: function mouseleaveRow(ev) {
      this.options.exit(ev.currentTarget);
    }
    /**
     * Immediately activate a row if the user clicks on it.
     * @param ev Mouse Event
     */

  }, {
    key: "clickRow",
    value: function clickRow(ev) {
      if (ev.currentTarget !== this.activeRow) {
        this.activate(ev.currentTarget);
      }

      this.options.clickRow(ev, ev.currentTarget); // pozovi registrirani event handler
    }
    /**
     * Activate a menu row.
     * @param row menu row which should be activated
     */

  }, {
    key: "activate",
    value: function activate(row) {
      if (row == this.activeRow) {
        return;
      }

      if (this.activeRow) {
        this.options.deactivate(this.activeRow);
      }

      var newRow = this.options.activate(row);

      if (newRow) {
        this.activeRow = newRow;
      } else {
        this.activeRow = row;
      }
    }
    /**
     * Possibly activate a menu row. If mouse movement indicates that we
     * shouldn't activate yet because user may be trying to enter
     * a submenu's content, then delay and check again later.
     *
     * @param row menu row to be activated
     */

  }, {
    key: "possiblyActivate",
    value: function possiblyActivate(row) {
      var delay = this.activationDelay();
      var self = this;

      if (delay) {
        this.timeoutId = setTimeout(function () {
          self.possiblyActivate(row);
        }, delay);
      } else {
        this.activate(row);
      }
    }
    /**
     * Return the amount of time that should be used as a delay before the
     * currently hovered row is activated.
     *
     * Returns 0 if the activation should happen immediately. Otherwise,
     * returns the number of milliseconds that should be delayed before
     * checking again to see if the row should be activated.
     */

  }, {
    key: "activationDelay",
    value: function activationDelay() {
      var activeRowFound = false;

      if (this.activeRow) {
        // IF active row is set
        // > check to see if it's of correct type
        var rows = this.activeRow.parentElement.querySelectorAll(this.options.submenuSelector);

        for (var i = 0, maxI = rows.length; i < maxI; i++) {
          if (rows[i] === this.activeRow) {
            activeRowFound = true;
            break;
          }
        }
      }

      if (!activeRowFound) {
        // IF there is no other submenu row already active, then
        // go ahead and activate immediately.
        return 0;
      }

      var offset = _offset(this.menu),
          upperLeft = {
        x: offset.left,
        y: offset.top - this.options.tolerance
      },
          upperRight = {
        x: offset.left + this.menu.offsetWidth,
        y: upperLeft.y
      },
          lowerLeft = {
        x: offset.left,
        y: offset.top + this.menu.offsetHeight + this.options.tolerance
      },
          lowerRight = {
        x: offset.left + this.menu.offsetWidth,
        y: lowerLeft.y
      },
          loc = _mouseLocs[_mouseLocs.length - 1],
          prevLoc = _mouseLocs[0];

      if (!loc) {
        return 0;
      }

      if (!prevLoc) {
        prevLoc = loc;
      }

      if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x || prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
        // If the previous mouse location was outside of the entire
        // menu's bounds, immediately activate.
        return 0;
      }

      if (this.lastDelayLoc && loc.x == this.lastDelayLoc.x && loc.y == this.lastDelayLoc.y) {
        // If the mouse hasn't moved since the last time we checked
        // for activation status, immediately activate.
        return 0;
      }

      var decreasingCorner = upperRight,
          increasingCorner = lowerRight; // Our expectations for decreasing or increasing slope values
      // depends on which direction the submenu opens relative to the
      // main menu. By default, if the menu opens on the **right**, we
      // expect the slope between the cursor and the upper right
      // corner to decrease over time, as explained above. If the
      // submenu opens in a different direction, we change our slope
      // expectations.

      if (this.options.submenuDirection == es6_menu_aim_types_1.MenuDirection.left) {
        decreasingCorner = lowerLeft;
        increasingCorner = upperLeft;
      } else if (this.options.submenuDirection == es6_menu_aim_types_1.MenuDirection.below) {
        decreasingCorner = lowerRight;
        increasingCorner = lowerLeft;
      } else if (this.options.submenuDirection == es6_menu_aim_types_1.MenuDirection.above) {
        decreasingCorner = upperLeft;
        increasingCorner = upperRight;
      }

      var decreasingSlope = _calcSlope(loc, decreasingCorner),
          increasingSlope = _calcSlope(loc, increasingCorner),
          prevDecreasingSlope = _calcSlope(prevLoc, decreasingCorner),
          prevIncreasingSlope = _calcSlope(prevLoc, increasingCorner);

      if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
        // Mouse is moving from previous location towards the
        // currently activated submenu. Delay before activating a
        // new menu row, because user may be moving into submenu.
        this.lastDelayLoc = loc;
        return DELAY;
      }

      this.lastDelayLoc = null;
      return 0;
    }
    /**
     * Hook up menu item events. This method allows menu
  * items to be added externaly
  */

  }, {
    key: "hookUp",
    value: function hookUp(li) {
      li.addEventListener('mouseenter', this.mouseenterRow);
      li.addEventListener('mouseleave', this.mouseleaveRow);
      li.addEventListener('click', this.clickRow);
    }
    /**
     * Sets a DOM node as currently active menu item.
     * This is to be used form external code in case
     * menu item list can dynamically change
     * @param row DOM node to be set active
     */

  }, {
    key: "setActiveRow",
    value: function setActiveRow(row) {
      this.activeRow = row;

      if (this.timeoutId) {
        // AKO već postoji schedulirani timeout -> resetiraj ga
        // console.log('schedule Exit CLEAR');
        window.clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      if (this.exitTimeoutID) {
        // AKO već postoji schedulirani timeout -> resetiraj ga
        // console.log('schedule Exit CLEAR');
        window.clearTimeout(this.exitTimeoutID);
        this.exitTimeoutID = null;
      }
    }
    /**
     * Deactivate menu item which is currently marked as active
     */

  }, {
    key: "deactivateRow",
    value: function deactivateRow() {
      if (this.activeRow) {
        this.options.deactivate(this.activeRow);
      }

      this.activeRow = null;
    }
    /**
     * Detaches MenuAim from DOM containser ... to be used
     * while disposing the menu
     */

  }, {
    key: "detach",
    value: function detach() {
      // preventing multiple calls
      if (!this.menu) {
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      if (--_instanceCounter === 0) {
        // IF this was the last existing instance of the class
        // > stop tracking the mouse cusros
        document.removeEventListener('mousemove', _mousemoveDocument);
      }

      if (this.options.isRoot) {
        this.menu.removeEventListener('mouseleave', this.mouseleaveMenu);
      }

      this.timeoutId = this.lastDelayLoc = this.activeRow = this.menu = null;
    }
  }]);

  return MenuAim;
}();

exports.MenuAim = MenuAim;
/**
 * Event handler which keep track of the last few locations of the mouse.
 * @param ev mouse event
 * @private
 */

var _mousemoveDocument = function _mousemoveDocument(ev) {
  _mouseLocs.push({
    x: ev.pageX,
    y: ev.pageY
  });

  if (_mouseLocs.length > MOUSE_LOCS_TRACKED) {
    _mouseLocs.shift();
  }
};
/**
 * Detect if the user is moving towards the currently activated
 * submenu.
 * If the mouse is heading relatively clearly towards
 * the content of submenu, we should wait and give the user more
 * time before activating a new row. If the mouse is heading
 * elsewhere, we can immediately activate a new row.
 * We detect this by calculating the slope formed between the
 * current mouse location and the upper/lower right points of
 * the menu. We do the same for the previous mouse location.
 * If the current mouse location's slopes are
 * increasing/decreasing appropriately compared to the
 * previous, we know the user is moving toward the submenu.
 * Note that since the y-axis increases as the cursor moves
 * down the screen, we are looking for the slope between the
 * cursor and the upper right corner to decrease over time, not
 * increase (somewhat counterintuitively).
 * @param a
 * @param b
 * @private
 */


var _calcSlope = function _calcSlope(a, b) {
  return (b.y - a.y) / (b.x - a.x);
};
/**
 * Returns coordinates of the given element relative to the window
 * @param elem DOM element who's coordinates need to be calculated
 * @private
 */


var _offset = function _offset(elem) {
  var rect = elem.getBoundingClientRect(),
      win = elem.ownerDocument.defaultView;
  return {
    top: rect.top + win.pageYOffset,
    left: rect.left + win.pageXOffset
  };
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MenuDirection;

(function (MenuDirection) {
  MenuDirection["left"] = "left";
  MenuDirection["right"] = "right";
  MenuDirection["below"] = "below";
  MenuDirection["above"] = "above";
})(MenuDirection || (MenuDirection = {}));

exports.MenuDirection = MenuDirection;

/***/ })
/******/ ]);
});
//# sourceMappingURL=es6-menu-aim.js.map
